<!--
    备注编辑模块
    作用：编辑备注
    实现：弹窗操作；
    组件：element->el-dialog
    注释：WJ
-->
<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        :close-on-click-modal="false"
        title="备注"
        width="800px">
        <RemarkDetail
            :data.sync="newData"
        />
        <span
            slot="footer"
            class="dialog-footer">
          <el-button
              type="primary"
              @click="handleSend">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import RemarkDetail from './components/remarkDetail'
    export default {
        name: 'remark',
        components: {
            RemarkDetail
        },
        props: {
            visible: {
                type: Boolean,
                default: false,
            },
            data: [Object, Array]
        },
        watch: {
            dialogVisible(vl) {
                this.$emit('update:visible', vl);
            },
            visible(vl) {
                this.dialogVisible = vl;
            },
            data(vl){this.newData = vl},
            newData(vl){this.$emit('update:data',vl)}
        },
        data() {
            return {
                newData: this.data,
                dialogVisible: this.visible,
                htmlContent: '', // 富文本内容
            };
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
            },
            change(html) {
                this.htmlContent = html;
            },
            close(){
                this.dialogVisible = false
                this.htmlContent = ''
            },
            handleSend(){
                this.close()
            }
        },
    };
</script>

<style scoped>

</style>
